import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const headCell = {
  fontWeight: 700,
  fontSize: "13px",
  color: "#fff",
  background: "#04343a",
  borderBottom: "none",
  padding: "12px 16px",
};

const IntroPageTable = ({ rows, onEdit, onDelete }) => {
  return (
    <>
      <TableContainer component={Paper} elevation={0} sx={{ borderTop: "1px solid #eef2f7" }}>
        <Table>
          <TableHead>
            <TableRow>
              {["ID", "Order", "Image URL", "Actions"].map((label) => (
                <TableCell key={label} sx={{ ...headCell, textAlign: label === "Actions" ? "center" : "left" }}>
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                  No records found.
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <TableRow key={row.id} sx={{ "&:hover": { background: "#f0faf5" } }}>
                  <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{row.id}</TableCell>
                  <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{row.order}</TableCell>
                  <TableCell>
                    <Tooltip title={row.image_url} placement="top" arrow>
                      <span style={{ color: "#016551", fontWeight: 600, fontSize: "14px" }}>
                        {row.image_url && row.image_url.length > 40
                          ? row.image_url.substring(0, 40) + "..."
                          : row.image_url}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton size="small" sx={{ color: "#04343a" }} onClick={() => onEdit(row)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" sx={{ color: "#e53935" }} onClick={() => onDelete(row.id)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default IntroPageTable;
